var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.status === _vm.PENDING
    ? _c("span", { staticClass: "text-warning" }, [
        _vm._v(
          "\n  " + _vm._s(_vm.$t("status." + _vm.docType + ".pending")) + "\n"
        )
      ])
    : _vm.status === _vm.UNCOMPLETED
    ? _c("span", { staticClass: "text-info" }, [
        _vm._v(
          "\n  " + _vm._s(_vm.$t("status." + _vm.docType + ".topay")) + "\n"
        )
      ])
    : _vm.status === _vm.COMPLETED
    ? _c("span", { staticClass: "text-success" }, [
        _vm._v(
          "\n  " + _vm._s(_vm.$t("status." + _vm.docType + ".completed")) + "\n"
        )
      ])
    : _vm.status === _vm.REJECTED
    ? _c("span", { staticClass: "text-danger" }, [
        _vm._v(
          "\n  " + _vm._s(_vm.$t("status." + _vm.docType + ".rejected")) + "\n"
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-17afb847", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-17afb847","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/BaseDocumentProcessStatus.vue
// module id = null
// module chunks = 